export const groupBy = (arr, key) => arr.reduce((groups, item) => {
    ;
    (groups[key(item)] ||= []).push(item);
    return groups;
}, {});
